/**
 * Log a warning message to the console with bootstrap-vue formatting sugar.
 * @param {string} message
 */
function warn(message) {
    console.warn(`[Bootstrap-Vue warn]: ${message}`)
}

export default warn



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/utils/warn.js
// module id = 123
// module chunks = 2